/** Small pill switch for one setting: options = [[value, label], …]. */
export default function Segmented({ label, value, options, onChange, testId, disabled, off = [] }) {
  return (
    <div>
      <div className="mb-1.5 font-mono text-[10px] uppercase tracking-[0.16em] text-white/50">{label}</div>
      <div className="flex rounded-full border border-white/10 bg-black/40 p-1" role="radiogroup" aria-label={label}>
        {options.map(([v, l]) => (
          <button key={v} type="button" role="radio" aria-checked={value === v} disabled={disabled || off.includes(v)} data-testid={`${testId}-${v}`}
            onClick={() => onChange(v)}
            className={`flex-1 rounded-full px-2 py-1.5 text-[12px] font-medium transition-colors ${value === v ? "bg-amber-300 text-black" : "text-white/60 hover:text-white"} disabled:cursor-not-allowed disabled:opacity-35`}>
            {l}
          </button>
        ))}
      </div>
    </div>
  );
}
